<script>
  import { Router } from "@roxi/routify";
  import { routes } from "../.routify/routes.default";
</script>

<div>
  <Router {routes} />
</div>
